import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class ApiSocketService extends Socket {

  	constructor(private apiService: ApiService) {

		super({
			url: '/',
			options: {
				path: '/api/io',
				autoConnect: false
			}
		});

		this.ioSocket.on('connect_error', error => {
			
			if(!this.apiService.isAuthenticated)
				this.disconnect();
			
			console.error(error);
		});
	}

	connect () {
		if(this.apiService.isAuthenticated) {
			this.ioSocket.auth = { token: this.apiService.token };
			this.ioSocket.autoConnect = true;
			this.ioSocket.reconnection = true;
			super.connect();
		}
	}

	disconnect () {
		this.ioSocket.autoConnect = false;
		this.ioSocket.reconnection = false;
		this.ioSocket.auth = {};
		super.disconnect();
	}
}
